import React, { createRef } from "react";
import ReactMarkdown from "react-markdown";
import { Modal } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import remarkGfm from "remark-gfm";
import styles from "./markdown-styles.module.scss";
import html2pdf from "html2pdf.js";
import rehypeRaw from "rehype-raw";
import { StoreContext } from "../contexts/StoreContext";

const PDF_DOWNLOAD_FORMATS = {
  A0: "A0",
  // other format disabled in SDD-1240 as huge files created blank page with those format
  // A1: "A1",
  // A2: "A2",
  // A3: "A3",
  // A4: "A4",
  // A5: "A5",
};

@inject("detailViewStore", "previewStore", "popupStore")
@observer
export class TrMarkdownModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPdfFormat: PDF_DOWNLOAD_FORMATS.A0,
    };
  }
  static contextType = StoreContext;
  render() {
    const { toggleTrModal, show, name } = this.props;
    const { getEntityData } = this.context;
    const markdownContentRef = createRef();
    const transformationRuleWrapper =
      getEntityData.item &&
      getEntityData.item.otherInformation &&
      getEntityData.item.otherInformation.transformationRules &&
      getEntityData.item.otherInformation.transformationRules.length > 0
        ? getEntityData.item.otherInformation.transformationRules[0]
        : null;
    const transformationRule = transformationRuleWrapper?.transformationRule;
    const markdownText = transformationRuleWrapper?.content;
    const errorMessage = `## ⚠️**Failed to load .md file**`;
    return (
      <div className="markdown">
        <Modal
          animation={false}
          show={show}
          onHide={() => toggleTrModal(false)}
          dialogClassName="TR-modal-window-width"
        >
          <Modal.Header closeButton>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "15px",
              }}
            >
              <Modal.Title>{name}</Modal.Title>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "75px",
                }}
              >
                {!!markdownText ? (
                  <div>
                    {/* <Select
                    // other format disabled in SDD-1240 as huge files created blank page with those format
                      clearable={false}
                      name="dropdown-pdf-format"
                      value={this.state.selectedPdfFormat}
                      onChange={(value) => this.handleChangePdfFormat(value)}
                      options={Object.values(PDF_DOWNLOAD_FORMATS).map(
                        (item) => {
                          return {
                            label: item,
                            value: item,
                            clearableValue: false,
                          };
                        }
                      )}
                    /> */}
                    <span
                      className="glyphicon glyphicon-download-alt"
                      style={{
                        float: "right",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() =>
                        this.downloadHtmlAsPdf(
                          markdownContentRef,
                          transformationRule
                        )
                      }
                    ></span>
                  </div>
                ) : null}
              </div>
            </div>
          </Modal.Header>
          <div ref={markdownContentRef}>
            <ReactMarkdown
              className={styles.markdown}
              children={!!markdownText ? markdownText : errorMessage}
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
            />
          </div>
        </Modal>
      </div>
    );
  }

  handleChangePdfFormat = (value) => {
    this.setState({
      selectedPdfFormat: value.value ?? PDF_DOWNLOAD_FORMATS.A4,
    });
  };

  downloadHtmlAsPdf = (markdownContentRef, transformationRule) => {
    if (!markdownContentRef?.current) {
      return;
    }

    const contentCopy = markdownContentRef.current.cloneNode(true);
    this.updateHtmlContentForPdfExport(contentCopy);

    const options = {
      margin: 1,
      filename: transformationRule
        ? `${transformationRule.name}.pdf`
        : "transformation-rule.pdf",
      pagebreak: { mode: ["avoid-all"] },
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: this.state.selectedPdfFormat ?? "A4",
        orientation: "portrait",
        compress: true,
      },
      timeout: 120000,
    };

    // automatic PDF download
    html2pdf(contentCopy, options);
  };

  updateHtmlContentForPdfExport = (htmlContent) => {
    const detailsElems = htmlContent.getElementsByTagName("details");
    Array.from(detailsElems).forEach((element) => {
      element.setAttribute("open", "");
    });
  };
}
